import React from 'react';
import { Icon, Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  learnerUpdateActionSelector,
  UPDATE_ACTIONS,
  setLearnerUpdateAction,
} from 'features/classCreation';
import styles from './AddOrRemoveLearnersActions.module.scss';

function AddOrRemoveLearnersActions() {
  const dispatch = useDispatch();
  const learnerUpdateAction = useSelector(learnerUpdateActionSelector);

  const handleClick = (type) => {
    dispatch(setLearnerUpdateAction(type));
  };

  return (
    <div className="row m-b-m">
      <Tappable
        className={classNames(styles.modify, 'm-r-xs', {
          [styles.selected]: learnerUpdateAction === UPDATE_ACTIONS.add,
        })}
        onClick={() => handleClick(UPDATE_ACTIONS.add)}
        noHighlight
      >
        <Icon
          name="plus-circle"
          className="m-r-xxs"
        />
        Add Learners
      </Tappable>
      <Tappable
        className={classNames(styles.modify, {
          [styles.selected]: learnerUpdateAction === UPDATE_ACTIONS.remove,
        })}
        onClick={() => handleClick(UPDATE_ACTIONS.remove)}
        noHighlight
      >
        <Icon
          name="minus-circle"
          className="m-r-xxs"
        />
        Remove Learners
      </Tappable>
    </div>
  );
}

export default AddOrRemoveLearnersActions;
